import { useState, useCallback, useRef, useEffect } from 'react';

/**
 * Hook para gestionar dropdown con posicionamiento dinámico
 */
export const useDropdown = () => {
    const [activeId, setActiveId] = useState(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const timeoutRef = useRef(null);

    const open = useCallback((id, triggerElement) => {
        if (triggerElement) {
            const rect = triggerElement.getBoundingClientRect();
            setPosition({
                top: rect.bottom + 4,
                left: rect.left
            });
        }
        setActiveId(id);
    }, []);

    const close = useCallback(() => {
        setActiveId(null);
    }, []);

    const toggle = useCallback((id, triggerElement) => {
        if (activeId === id) {
            close();
        } else {
            open(id, triggerElement);
        }
    }, [activeId, open, close]);

    const startTimeout = useCallback((callback, delay = 3000) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(callback, delay);
    }, []);

    const clearActiveTimeout = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    }, []);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return {
        activeId,
        position,
        open,
        close,
        toggle,
        startTimeout,
        clearActiveTimeout
    };
};